import React, { type PropsWithChildren } from 'react';
import { Placement } from '@post-office/placements/jira-filter-refinement-filter-button';
import { expVal } from '@atlassian/jira-feature-experiments';

type Props = PropsWithChildren<{
	isEnabled?: boolean;
}>;

export const ChangeBoarding = ({ children, isEnabled }: Props) => {
	if (!isEnabled || !expVal('filter_refinement_in_tmp_backlog', 'isEnabled', false)) {
		return children;
	}

	return <Placement>{children}</Placement>;
};
